<script>
  import { Router, Link, Route } from "svelte-routing";
  import { SidebarNav } from "./sidebar-nav";
  import { Header } from "./header";
  import { Footer } from "./footer";
  import { routes } from "./routes";
  import { links } from "svelte-routing";
</script>

<Router >
  <Header />
  <div use:links class="container-fluid">
    <div class="row-fluid">
      <div class="span3" id="sidebar">
        <SidebarNav />
        <h4 style="padding-top:20px">Cambiar fecha de trabajo a:</h4>
        <div class="controls">
          <!-- @Html.TextBox("date", DateTime.Today, @"{0:dd/MM/yyyy}", new { @type = "date", @class = "datepicker", id = "date" }) -->
          <!-- @Html.ValidationMessage("date", "", new { @class = "font-red" }) -->
        </div>
        <div style="padding-left:50px">
          <input
            value="Cambiar"
            class="btn btn-primary"
            id="SetDate"
            type="button" />
        </div>
      </div>
      <div class="span9" id="content">
        <div id="rFD" class="row-fluid" />
        <a href="/home" >go</a>
        <Route path="home" component={SidebarNav} />
        <Route path="/"><Footer/></Route>
      </div>
    </div>

    <Footer />
  </div>
  <div class="top-right jGrowl" id="jGrowl">
    <div class="jGrowl-notification" />
  </div>
</Router>
